// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'تم نقل ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'اكتمل الإجراء ' + p['label'],
  accButtonProgressStatus: (p: { label: string }) => 'إجراء ' + p['label'] + ' قيد التقدم',
  accColorPalette: () => 'لوحة الألوان',
  accColorSwatch: () => 'عينات الألوان',
  accCommandKey: () => 'الأمر',
  accContextMenuLabel: () => 'الإجراءات',
  accControlKey: () => 'إغلاق',
  accPositionAfter: () => 'بعد',
  accPositionBefore: () => 'قبل',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'اضغط باستمرار على مفتاحي ' +
    p['keyPressed'] +
    ' وshift، ثم استخدم مفاتيح الأسهم لإعادة الترتيب.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'أدخل تاريخًا كاملاً مثل هذا: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'أدخل شهرًا وسنة مثل هذا: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'التسمية',
  chart_labelGroup: () => 'المجموعة',
  chart_labelSeries: () => 'المتوالية',
  chart_labelValue: () => 'القيمة',
  chart_labelWidthWeight: () => 'المحور ع',
  chart_labelX: () => 'س',
  chart_labelY: () => 'ص',
  checkboxSet_requiredMessageDetail: () => 'حدد قيمة.',
  checkbox_helpForCheckbox: () => 'تعليمات لمربع الاختيار',
  checkbox_requiredMessageDetail: () => 'حدد قيمة.',
  checkbox_selected: () => 'تم تحديد مربع الاختيار',
  checkbox_unselected: () => 'لم يتم تحديد مربع الاختيار',
  close: () => 'إغلاق',
  collection_apply: () => 'تطبيق',
  collection_cancel: () => ' إلغاء',
  collection_loaded: () => 'مُحمَّل',
  collection_loading: () => 'جارٍ التحميل',
  collection_noData: () => 'لا توجد بيانات.',
  collection_pixels: () => 'بكسل',
  collection_resizeColumnDialog: () => 'إعادة تحجيم عمود',
  collection_resizeColumnMenu: () => 'إعادة تحجيم عمود...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'أدخل رقمًا بين ' + p['MIN'] + ' و' + p['MAX'] + '.',
  collection_selectAllRows: () => 'تحديد كل الصفوف',
  collection_selectRow: (p: { ROW_NAME: string }) => 'تحديد الصف ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'تصاعدي',
  collection_sortColumnMenu: () => 'فرز العمود',
  collection_sortDescendingSubMenu: () => 'تنازلي',
  collection_sortDisabled: () => 'غير قابل للفرز',
  collection_sortEnabled: () => 'قابل للفرز',
  collection_width: () => 'عرض',
  colorPicker_label: () => 'منتقي الألوان',
  confirmation: () => 'تأكيد',
  datePicker_currentDate: () => 'التاريخ الحالي',
  datePicker_goToToday: () => 'الانتقال إلى اليوم',
  datePicker_label: () => 'منتقي التاريخ',
  datePicker_month: () => 'شهر',
  datePicker_months: () => 'الأشهر',
  datePicker_next: () => 'التالي',
  datePicker_nextDecade: () => 'العقد التالي',
  datePicker_nextMonth: () => 'الشهر التالي',
  datePicker_prev: () => 'السابق',
  datePicker_prevDecade: () => 'العقد السابق',
  datePicker_prevMonth: () => 'الشهر السابق',
  datePicker_restricted: () => 'مقيد',
  datePicker_selected: () => 'محدد',
  datePicker_today: () => 'اليوم',
  datePicker_weekNum: (p: { NUM: string }) => 'الأسبوع ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'رقم الأسبوع',
  datePicker_year: () => 'سنة',
  datePicker_years: () => 'السنوات',
  diagram_promotedLink: () => '1 الارتباط',
  diagram_promotedLinkAriaDesc: () => 'غير مباشر',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' من الارتباطات',
  error: () => 'خطأ',
  expandableList_expandCollapseInstructionText: () => 'استخدام مفاتيح الأسهم للتوسيع والطي',
  expandableList_groupCollapse: () => 'مطوي',
  expandableList_groupExpand: () => 'موسع',
  filePicker_addFiles: () => 'إضافة ملفات',
  filePicker_dropzonePrimaryText: () => 'سحب وإسقاط',
  filePicker_dropzoneSecondaryText: () => 'تحديد ملف أو إسقاط واحد هنا',
  filePicker_dropzoneSecondaryTextMultiple: () => 'تحديد الملفات أو إسقاطها هنا',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'يتعذر عليك تحميل ملفات من النوع ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'تحميل ملف واحد في كل مرة',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'يتعذر عليك تحميل ملفات من النوع ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'غير معروف',
  formControl_clear: () => 'مسح',
  formControl_day: () => 'يوم',
  formControl_empty_segment: () => 'فارغ',
  formControl_helpAvailable: () => 'تتوفر التعليمات',
  formControl_hide: () => 'إخفاء',
  formControl_hour: () => 'ساعة',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'لقد وصلت للحد ' +
    ((
      {
        zero: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' أحرف',
        one: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' حرف',
        two: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' حرفين',
        few: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' أحرف',
        many: new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' حرفًا'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('ar').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ar').format(p['CHARACTER_LIMIT']) + ' حرف') +
    ' limit.',
  formControl_loading: () => 'جارٍ التحميل',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'يمكنك إدخال ما يصل إلى ' + p['MAX_LENGTH'] + ' من الحروف.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'تم تجاوز الحد الأقصى للطول ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'يتبقى ' + p['CHARACTER_COUNT'] + ' من الحروف.',
  formControl_millisecond: () => 'ملي ثانية',
  formControl_minute: () => 'دقيقة',
  formControl_month: () => 'شهر',
  formControl_readOnly: () => 'للقراءة فقط',
  formControl_requiredMessageDetail: () => 'أدخل قيمة.',
  formControl_second: () => 'ثانية',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'تحديد ' + p['n'] + ' من القيم.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'لقد وصلت إلى حد التحديد ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'تحديد من ' + p['min'] + ' إلى ' + p['max'] + ' من القيم.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'تحديد ' + p['min'] + ' من القيم على الأقل.',
  formControl_show: () => 'إظهار',
  formControl_year: () => 'سنة',
  gantt_labelDate: () => 'التاريخ',
  gantt_labelEnd: () => 'النهاية',
  gantt_labelLabel: () => 'التسمية',
  gantt_labelRow: () => 'الصف',
  gantt_labelStart: () => 'البداية',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. لم يتم العثور على مقاطع مطابقة.',
  indexer_keyboardInstructionText: () => 'اضغط على enter لتحديد قيمة.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'بين ' + p['FROM_SECTION'] + ' و' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'انقر نقرًا مزدوجًا واستمر في الضغط للدخول في وضع الإيماء، ثم اسحب لأعلى أو لأسفل لتعديل القيمة.',
  info: () => 'معلومات',
  inputColor_selectColor: () => 'اختر لونًا',
  inputDateMask_date_cleared: () => 'تاريخ التصفية',
  inputDateMask_dayPlaceholder: () => 'ي ي',
  inputDateMask_empty_segment: () => 'فارغ',
  inputDateMask_monthPlaceholder: () => 'ش ش',
  inputDateMask_yearPlaceholder: () => 'س س س س',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'أدخل تاريخًا يوافق ' + p['max'] + ' أو يقع قبله.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'أدخل تاريخًا يوافق ' + p['min'] + ' أو يقع بعده.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'أدخل تاريخًا متاحًا.',
  inputDatePicker_instruction: () => 'اضغط على علامة التبويب للوصول إلى التقويم.',
  inputDatePicker_selectDate: () => 'تحديد تاريخ',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'أدخل شهرًا وسنة في أو قبل ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'أدخل شهرًا وسنة في أو بعد ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'أدخل رقمًا.',
  inputNumber_decrease: () => 'تقليل',
  inputNumber_increase: () => 'زيادة',
  inputPassword_hidden: () => 'تم إخفاء كلمة السر',
  inputPassword_hide: () => 'إخفاء كلمة السر',
  inputPassword_show: () => 'إظهار كلمة السر',
  inputSensitiveText_hidden: () => 'نص حساس لحالة الأحرف مخفي',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'أدخل وقتًا يبلغ ' + p['max'] + ' أو قبله.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'أدخل وقتًا يساوي ' + p['min'] + ' أو بعده.',
  inputTimeMask_time_cleared: () => 'تم مسح الوقت',
  labelNone: () => 'لا توجد عناصر',
  list_msgFetchCompleted: () => 'مُحمَّل',
  list_msgFetchingData: () => 'جارٍ التحميل',
  list_suggestion: () => 'الاقتراح',
  menu_stateLoading: () => 'جارٍ التحميل',
  messageToast_allMessagesClosed: () => 'تم إغلاق كل الرسائل المؤقتة.',
  message_close: () => 'إغلاق',
  message_confirmation: () => 'نجاح',
  message_error: () => 'خطأ',
  message_info: () => 'معلومات',
  message_navigationFromMessagesRegion: () => 'إدخال منطقة الرسائل. اضغط على F6 للتنقل.',
  message_navigationToMessagesRegion: () => 'تشتمل منطقة الرسائل على رسائل جديدة. اضغط F6 للتنقل.',
  message_navigationToTouch: () => 'لا تحتوي منطقة الرسائل على رسائل جديدة.',
  message_warning: () => 'تحذير',
  noData_message: () => 'لا توجد عناصر لعرضها',
  overflowItemLabel: () => 'المزيد من علامات التبويب',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'اضغط ضغطًا مزدوجًا لإغلاق القائمة المنبثقة المفتوحة.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'الدخول في القائمة المنبثقة. اضغط على F6 للتنقل بين القائمة المنبثقة وعنصر التحكم المقترن.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'القائمة المنبثقة مفتوحة. اضغط على F6 للتنقل بين القائمة المنبثقة وعنصر التحكم المقترن.',
  progressIndeterminate: () => 'قيد التقدم',
  radioButton_checked: () => 'تم تحديد زر الاختيار',
  radioButton_selected: () => 'تم تحديد زر اختيار',
  radioButton_unchecked: () => 'لم يتم تحديد زر الاختيار',
  radioButton_unselected: () => 'لم يتم اختيار زر الاختيار',
  radio_helpForRadio: () => 'تعليمات لزر الاختيار',
  radio_requiredMessageDetail: () => 'حدد قيمة.',
  selectMultiple_apply: () => 'تطبيق',
  selectMultiple_back: () => 'عودة',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'استخدم زري السهمين لليمين واليسار لتمييز القيم المحددة.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'انقر على Backspace أو Delete لإزالة القيمة المحددة.',
  selectMultiple_selectedValues: () => 'قيم محددة',
  selectMultiple_showSelectedValues: () => 'عرض القيم المحددة فقط.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'تم تحديد ' + p['VALUE_COUNT'] + ' من القيم.',
  select_addToList: () => 'إضافة إلى القائمة',
  select_addToListAvailable: () => 'تتوفر الإضافة إلى القائمة',
  select_closeDropdown: () => 'اضغط على Escape للإغلاق.',
  select_moreSearchOptions: () => 'مزيد من خيارات البحث',
  select_moreSearchOptionsAvailable: () => 'تتوفر المزيد من خيارات البحث',
  select_noMatchesFound: () => 'لم يتم العثور على عناصر مطابقة.',
  select_oneMatchFound: () => 'تم العثور على عنصر مطابق واحد',
  select_requiredMessageDetail: () => 'حدد قيمة.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'تم العثور على ' + p['TOTAL_SIZE'] + ' من المطابقات',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'تم العثور على ' + p['TOTAL_SIZE'] + ' من المطابقات أو أكثر',
  selectorAll_deselectAll: () => 'إلغاء تحديد الكل',
  selectorAll_selectAll: () => 'تحديد الكل',
  selector_selected: () => 'تم تحديد مربع الاختيار',
  selector_unselected: () => 'لم يتم تحديد مربع الاختيار',
  sheet_close: () => 'إغلاق',
  switch_off: () => 'إيقاف',
  switch_on: () => 'بتاريخ',
  tabBarNavigationList_removeCueText: () => 'قابل للإزالة',
  tabBar_tabContainsErrors: () => 'يحتوي على أخطاء',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'تمت إزالة ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'يشتمل على قائمة سياق',
  tabbar_labelMoveLeft: () => 'نقل لليسار',
  tabbar_labelMoveRight: () => 'نقل لليمين',
  tabbar_labelRemove: () => 'إزالة',
  timeComponent_tooltipZoomIn: () => 'تقريب',
  timeComponent_tooltipZoomOut: () => 'إبعاد',
  timeConverter_parseError: () => 'أدخل الوقت بالكامل.',
  train_current: () => 'الحالي',
  train_message_type: () => 'نوع الرسالة',
  train_not_visited: () => 'لم تتم الزيارة',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'الخطوة ' + p['currentStep'] + ' من أصل ' + p['numberOfSteps'],
  train_visited: () => 'تمت الزيارة',
  userAssistance_learnMore: () => 'تعرف على المزيد',
  userAssistance_required: () => 'مطلوب',
  vis_clearSelection: () => 'مسح الاختيار',
  vis_drillable: () => 'قابل للتنقل',
  vis_invalidData: () => 'البيانات غير صالحة',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' من أصل ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'تحديد نص متحرك',
  vis_marqueeZoomTooltip: () => 'تكبير/تصغير نص متحرك',
  vis_noData: () => 'لا توجد بيانات',
  vis_panTooltip: () => 'تحريك',
  vis_stateCollapsed: () => 'مطوي',
  vis_stateExpanded: () => 'موسع',
  vis_stateLoaded: () => 'مُحمَّل',
  vis_stateLoading: () => 'جارٍ التحميل',
  vis_stateSelected: () => 'محدد',
  vis_stateUnselected: () => 'غير محدد',
  warn: () => 'تحذير'
};
export default bundle;
